<script lang="ts">
  import { page } from '$app/stores';

  import { useConnect } from '@do/svelte-web3-manager';

  import { BlaizeLabel } from '@shared/ui/blaize-label';
  import { Button } from '@shared/ui/buttons/button';

  const { connect, isConnecting } = useConnect();

  $: galleryName = $page.data.configurations.name;
</script>

<section>
  <p class="mb-6 text-base">
    To purchase digital artworks and to participate in {galleryName} auctions, you need to connect your cryptocurrency wallet
    that supports the Ethereum network with the ERC-20 standard.
  </p>

  <p class="mb-6 text-base">
    For the best experience, you should use a browser on a PC, for example,
    <a href="https://www.google.com/chrome/" target="_blank" class="underline"> Google Chrome. </a>
  </p>

  <div class="mb-4">
    <Button on:click="{() => connect()}" loading="{$isConnecting}">Connect Wallet</Button>
  </div>

  <BlaizeLabel classes="w-full justify-center" />
</section>
